module.exports = __webpack_public_path__ + "static/media/icn_basket.6cac9e2b.svg";